export default "__VITE_ASSET__24995305__"